document.addEventListener('DOMContentLoaded', () => {
  const radios = document.querySelectorAll('input[name="climateMode"]');
  const t = (key) => (window.i18nHeatingCalc && window.i18nHeatingCalc[key]) || key;

  const sections = {
    temp: document.getElementById('mode-temp'),
    humidity: document.getElementById('mode-humidity'),
    both: document.getElementById('mode-both')
  };

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      Object.values(sections).forEach(sec => sec.style.display = 'none');
      if (radio.value === 'both') {
        sections.temp.style.display = 'flex';
        sections.humidity.style.display = 'flex';
      } else {
        sections[radio.value].style.display = 'flex';
      }
    });
  });

  const tOut = document.getElementById('min-out-temp');
  const tIn = document.getElementById('min-in-temp');
  const tDiff = document.getElementById('temp-diff');
  if (tOut && tIn && tDiff) {
    [tOut, tIn].forEach(el => {
      el.addEventListener('input', () => {
        const v = (+tIn.value || 0) - (+tOut.value || 0);
        tDiff.value = v.toFixed(1);
      });
    });
  }

  const form = document.getElementById('heater-form');
  const resultBox = document.getElementById('heater-result');
  const materialSelect = document.getElementById('material');
  const uInput = document.getElementById('u-value');

  materialSelect.addEventListener('change', () => {
    const val = materialSelect.value;
    if (val === 'custom') {
      uInput.value = '';
      uInput.removeAttribute('readonly');
      uInput.focus();
    } else if (val) {
      uInput.value = val;
      uInput.setAttribute('readonly', 'readonly');
    }
  });

  uInput.addEventListener('focus', () => {
    if (uInput.hasAttribute('readonly')) uInput.blur();
  });

  form.addEventListener('submit', e => {
    e.preventDefault();
    if (!materialSelect.value) {
      alert(t('select_material'));
      return;
    }

    const areaFn = (H, W, D, coef) => H*W*coef[0] + H*D*coef[1] + W*D*coef[2];
    const coefMatrix = [
      [1.8,1.8,1.8],[1.8,1.4,1.8],[1.8,1.0,1.8],
      [1.4,1.8,1.8],[1.4,1.8,1.8],[1.4,1.0,1.8],
      [1.8,1.8,1.4],[1.8,1.4,1.4],[1.8,1.0,1.4],
      [1.4,1.8,1.4],[1.4,1.4,1.4],[1.4,1.0,1.4]
    ];

    const h = +document.getElementById('cab-height').value || 0;
    const w = +document.getElementById('cab-width').value || 0;
    const d = +document.getElementById('cab-depth').value || 0;
    const H = h / 1000, W = w / 1000, D = d / 1000;
    const coefIndex = +document.getElementById('mounting').value;
    const area = areaFn(H, W, D, coefMatrix[coefIndex]);
    const coefficient = Number(uInput.value);
    const lc = +document.getElementById('location').value;
    const mode = document.querySelector('input[name="climateMode"]:checked');

    let tLow = 0, tHigh = 0, difference = 0;

    if (mode) {
      switch (mode.value) {
        case 'temp': {
          tLow = +document.getElementById('min-out-temp').value || 0;
          tHigh = +document.getElementById('min-in-temp').value  || 0;
          difference = tHigh - tLow;
          break;
        }
        case 'humidity': {
          const ta = +document.getElementById('max-out-temp').value || 0;
          const rha = +document.getElementById('max-hum-out').value || 0;
          const rhd = +document.getElementById('target-hum-in').value || 0;
          const alpha = +document.getElementById('h-altitude').value || 1;

          const temp = Math.log(rha * alpha / 100) + (17.62 * ta) / (243.12 + ta);
          const td = 243.12 * temp / (17.62 - temp);
          const t2_up =
              17.62 * 243.12 * td -
              Math.log(rhd * alpha / 100) * (243.12 * td + Math.pow(243.12,2));
          const t2_down =
              Math.log(rhd * alpha / 100) * (td + 243.12) + (17.62 * 243.12);
          const t2 = (t2_up / t2_down) - ta;

          difference = t2;
          tLow = ta;
          tHigh = ta + difference;
          break;
        }
        case 'both': {
          const minOut = +document.getElementById('min-out-temp').value || 0;
          const minIn  = +document.getElementById('min-in-temp').value  || 0;
          const diffTemp = minIn - minOut;

          const ta  = +document.getElementById('max-out-temp').value   || 0;
          const rha = +document.getElementById('max-hum-out').value    || 0;
          const rhd = +document.getElementById('target-hum-in').value  || 0;
          const alpha = +document.getElementById('h-altitude').value   || 1;

          const temp = Math.log(rha * alpha / 100) + (17.62 * ta) / (243.12 + ta);
          const td = 243.12 * temp / (17.62 - temp);
          const t2_up =
              17.62 * 243.12 * td -
              Math.log(rhd * alpha / 100) * (243.12 * td + Math.pow(243.12,2));
          const t2_down =
              Math.log(rhd * alpha / 100) * (td + 243.12) + (17.62 * 243.12);
          const diffHumidity = (t2_up / t2_down) - ta;

          difference = Math.max(diffTemp, diffHumidity);
          tLow = Math.min(minOut, ta);
          tHigh = tLow + difference;
          break;
        }
      }
    }

    const stray = +document.getElementById('power-loss').value || 0;
    const qNeeded = area * coefficient * lc * difference - stray;

    const html = `
      <p>${t('label')}</p>
      <strong>${isNaN(qNeeded) ? '–' : qNeeded.toFixed(1)} W</strong>
      <p class="note">${t('note').replace('{{area}}', area.toFixed(2))}</p>
    `;
    show(html);
  });

  function show(html, isErr = false) {
    resultBox.style.display = 'block';
    resultBox.style.fontSize = '2rem';
    resultBox.style.color = isErr ? '#991b1b' : '#111827';
    resultBox.style.background = isErr ? '#fee2e2' : '#f8fafc';
    resultBox.innerHTML = html;
  }
});